import { render, staticRenderFns } from "./video-upscaler.vue?vue&type=template&id=3db41e8c&scoped=true&"
import script from "./video-upscaler.vue?vue&type=script&lang=js&"
export * from "./video-upscaler.vue?vue&type=script&lang=js&"
import style0 from "./video-upscaler.vue?vue&type=style&index=0&id=3db41e8c&prod&lang=scss&"
import style1 from "./video-upscaler.vue?vue&type=style&index=1&id=3db41e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db41e8c",
  null
  
)

export default component.exports